import http from "@seims/shared/src/services/HttpService";

const endpoint = `system/log/application/errors`;

const getSystemErrors = async ({type, first, max, text = null}) => {
  const urlPath = `${endpoint}?appName=${type}&offset=${first}&limit=${max}`;

  if (text !== null && text !== undefined && text !== "") {
    urlPath += `&searchText=${text}`;
  }
  const response = await http.get(urlPath);
  return response;
};

const getErrorDetails = async (id) => {
  const response = await http.get(`${endpoint}/${id}`);
  return response;
};

export default { getSystemErrors, getErrorDetails };
